import FormControl from '@mui/material/FormControl';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import React, {memo} from 'react';
import {FieldError} from '@/components/Common/FormContext';
import ExpandMoreOutlinedIcon from '@mui/icons-material/ExpandMoreOutlined';

// Migrated from globals.scss `.select-placeholder ::placeholder` (sole consumer: the
// disabled placeholder MenuItem below). Preserved unchanged — this MenuItem renders no
// descendant with an actual `::placeholder` pseudo-element, so the rule has never had a
// visible effect; kept as a faithful no-op migration rather than a behavior change.
const selectPlaceholderSx = {
    display: 'none',
    color: 'red',
    background: 'green',
    '& ::placeholder': {
        color: 'gray !important'
    }
} as const;

const SingleSelect = (props: any): any => {
    const {name, id, options, placeholder, className, single, ...rest} = props;
    return (
        <React.Fragment>
            <FormControl fullWidth>
                <Select
                    id={id}
                    name={name}
                    variant="outlined"
                    placeholder={placeholder}
                    displayEmpty
                    {...rest}
                    inputProps={{'aria-label': 'Without label'}}
                    className={`${className} parent-custom-select`}
                    IconComponent={ExpandMoreOutlinedIcon}
                    defaultValue="Select Budget"
                >
                    <MenuItem value="" disabled hidden sx={selectPlaceholderSx} className="select-option select-placeholder">
                        {placeholder}
                    </MenuItem>
                    {options &&
                        options?.map((option: any, index: any) => (
                            <MenuItem
                                className="select-option"
                                key={index + 1}
                                value={single ? option && option.value : option}
                                disabled={option.value === ''}
                            >
                                {option.label}
                            </MenuItem>
                        ))}
                </Select>
            </FormControl>
            <FieldError name={name} />
        </React.Fragment>
    );
};

export default memo(SingleSelect);
